<kion-support-banner
  *ngIf="baseSite$ | async as baseSite"
  [support]="{phone: baseSite.phoneNumber, mailAddress: baseSite.supportEmail, openingHours: baseSite.openingHours, contactFormUrl: contactLink}"
  [title]="{title: component.headline, titleSize: component.titleSize}"
  [subtitle]="component.content"
  [topStyle]="component.spaceTop"
  [background]="component.background"
></kion-support-banner>
